// Centralized, typed ENV with sensible defaults (build-time injected by Vite)
const E = import.meta.env as ImportMetaEnv;

/** Discriminated network union — avoids downstream `as tNetworkTypes` casts everywhere. */
type NetworkType = 'mainnet' | 'testnet';

export const ENV = {
  // General
  VITE_GRAPHQL_URL: E.VITE_GRAPHQL_URL ?? 'https://verulend-indexer.venture23.xyz/graphql',
  VITE_INDEXER_URL: E.VITE_INDEXER_URL ?? 'https://verulend-indexer.venture23.xyz',

  // Network & endpoints
  VITE_NETWORK_TYPE: (E.VITE_NETWORK_TYPE ?? 'testnet') as NetworkType,
  VITE_ALEO_BASE_URL: E.VITE_ALEO_BASE_URL ?? 'https://api.explorer.provable.com/v1',
  VITE_ALEO_EXPLORER_URL: E.VITE_ALEO_EXPLORER_URL ?? 'https://testnet.explorer.provable.com',
  VITE_ALEO_RPC: E.VITE_ALEO_RPC ?? 'https://testnetbeta.aleorpc.com',
  VITE_ALEO_TOKEN_REGISTRY: E.VITE_ALEO_TOKEN_REGISTRY ?? 'token_registry.aleo',

  // AMM programs and configs
  AMM_INTERFACE: E.VITE_AMM_INTERFACE ?? 'amm_interface_v.aleo',
  AMM_ORACLE_INTERFACE: E.VITE_AMM_ORACLE_INTERFACE ?? 'amm_orcl_intrfc_v.aleo',
  VITE_AMM_RESERVE_STATE: E.VITE_AMM_RESERVE_STATE ?? 'amm_rsrv_state.aleo',
  VITE_AMM_USER_STATE: E.VITE_AMM_USER_STATE ?? 'amm_usr_ste_v.aleo',
  VITE_AMM_INSTANT_CR: E.VITE_AMM_INSTANT_CR ?? 'amm_instant_cr.aleo',
  VITE_AMM_ADMIN: E.VITE_AMM_ADMIN ?? 'amm_admin_v.aleo',
  VITE_AMM_ORACLE: E.VITE_AMM_ORACLE ?? 'amm_oracle_v.aleo',

  // Oracle + request values
  VLINK_ORACLE: E.VITE_VLINK_ORACLE ?? 'vlink_oracle_v2.aleo',
  ALEO_REQUEST_HASH: E.VITE_ALEO_REQUEST_HASH ?? '69545840751771345196310203380793058459u128',
  USDC_REQUEST_HASH: E.VITE_USDC_REQUEST_HASH ?? '142709967224662814311225757187928108124u128',
  USDT_REQUEST_HASH: E.VITE_USDT_REQUEST_HASH ?? '220938201505672543703232741194538576644u128',

  // Program names
  CREDITS: E.VITE_CREDITS ?? 'credits.aleo',
  PONDO: E.VITE_PONDO ?? 'pondo_protocol.aleo',
  TOKEN_REGISTRY: E.VITE_TOKEN_REGISTRY ?? 'token_registry.aleo',

  // Token IDs
  PALEO_TOKEN_ID: E.VITE_PALEO_TOKEN_ID ?? '1751493913335802797273486270793650302076377624243810059080883537084141842600field',
  VUSDC_TOKEN_ID: E.VITE_VUSDC_TOKEN_ID ?? '1068104870852223474792716721054209526718172707571751136410402215071671722039field',
  VUSDT_TOKEN_ID: E.VITE_VUSDT_TOKEN_ID ?? '1068104870852223474792716721054209526718172707571751136410402215071671722041field',
  WALEO_TOKEN_ID: E.VITE_WALEO_TOKEN_ID ?? '3443843282313283355522573239085696902919850365217539366784739393210722344986field',
  USDCX_TOKEN_ID: E.VITE_USDCX_TOKEN_ID ?? '8189124743574544155175584070525057987736583525477854897710240432079147233566field'
} as const;

// Keep named exports for existing imports across the app
export const {
  VITE_GRAPHQL_URL,
  VITE_INDEXER_URL,
  VITE_NETWORK_TYPE,
  VITE_ALEO_BASE_URL,
  VITE_ALEO_EXPLORER_URL,
  VITE_ALEO_RPC,
  VITE_ALEO_TOKEN_REGISTRY,
  AMM_INTERFACE,
  AMM_ORACLE_INTERFACE,
  VITE_AMM_RESERVE_STATE,
  VITE_AMM_USER_STATE,
  VITE_AMM_INSTANT_CR,
  VITE_AMM_ADMIN,
  VITE_AMM_ORACLE,
  VLINK_ORACLE,
  ALEO_REQUEST_HASH,
  USDC_REQUEST_HASH,
  USDT_REQUEST_HASH,
  CREDITS,
  PONDO,
  TOKEN_REGISTRY,
  PALEO_TOKEN_ID,
  VUSDC_TOKEN_ID,
  VUSDT_TOKEN_ID,
  WALEO_TOKEN_ID,
  USDCX_TOKEN_ID
} = ENV;

export default ENV;
